export enum descriptionDeviceMaxChar {
  mobile = 140,
  desktop = 240
}
